import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS } from '@app/constants';
import { Text, View } from '@/styles/reactnative';
import { ThemeContext } from '@/theme/ThemeProvider';
import useTradeStore from '../../../../../../hooks/trade/tradeStore';
import BigNumber from 'bignumber.js';
import styled from 'styled-components';

const DerivativesAccountList = ({ title, amount }) => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const { t } = useTranslation();
  const { data: tradeStore } = useTradeStore();
  const currency = tradeStore?.pairs?.split('/')[1];

  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        marginTop: 6,
      }}
    >
      <TextStyle style={{ color: '#B5B5BC', fontSize: 12 }}>
        {title && t(title)}
      </TextStyle>
      <TextStyle style={{ color: '#fff', fontSize: 12 }}>
        {BigNumber(amount).toFormat(4)} {currency}
      </TextStyle>
    </View>
  );
};

export default DerivativesAccountList;

const TextStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  font-family: 'NanumSquareRound', sans-serif !important;
  font-size: 14px;
  line-height: 17px;
  color: #fff;
`;
